<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">仪器设备维护审批</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.applyStatus2" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model="formInline.serial_no" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item :label="`所属${$store.state.themeTitle}室`">
          <el-select v-model="formInline.training_room_id" clearable filterable :placeholder="`请选择`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column prop="serial_no" fixed label="设备编号" width="120">
          <template slot-scope="scope" v-if="scope.row.device_individual">
            <span>{{ scope.row.device_individual.serial_no }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="device_name" fixed label="设备名称" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="status" label="审批状态" width="150" label-class-name="applyStatus2"
          :formatter="format_arr">
        </custom-table-column>
        <custom-table-column prop="maintenance_desc" label="维护说明" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="maintenance_date" label="维护时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="review_name" label="审批人" width="100px">
        </custom-table-column>
        <custom-table-column prop="review_desc" label="说明原因" width="160px">
        </custom-table-column>
        <custom-table-column prop="review_time" label="审批时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="created_at" label="申请时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="training_room_name" :label="`所属${$store.state.themeTitle}室`" min-width="180px">
          <template slot-scope="scope" v-if="scope.row.device_individual">
            <span>{{ scope.row.device_individual.training_room_name }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属组织结构" width="180">
          <template slot-scope="scope" v-if="scope.row.device">
            <span>{{ scope.row.device.structure_1 }}{{ scope.row.device.structure_2 }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="device_model" label="型号" width="160">
          <template slot-scope="scope" v-if="scope.row.device">
            <span>{{ scope.row.device.device_model }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="specification" label="规格" width="160">
          <template slot-scope="scope" v-if="scope.row.device">
            <span>{{ scope.row.device.specification }}</span>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope" v-if="scope.row.status == 1">
            <el-button @click="handleOper(scope.row, 2, '通过')" type="text" size="small">通过</el-button>
            <el-button @click="handleOper(scope.row, 3, '否决')" type="text" size="small">否决</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="510px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="说明原因" prop="review_desc" :rules="isRefuse">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.review_desc"
            style="width:336px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', setStatus)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinOrgan, mixinFormatter],
  data() {
    return {
      formInline: {
        structure_1: '',
        structure_2: '',
        serial_no: '',
        device_name: '',
        training_room_id: '',
        status: '',
      },
      ruleForm: {
        id: '',
        status: '',
        review_desc: ''
      }
    };
  },
  components: {},
  computed: {
    isRefuse() {
      return this.ruleForm.status == 3?[{ required: true, message: '请输入', trigger: 'blur' }]:[];
    },
  },
  created() {
    this.$store.dispatch('getTarinMent');
  },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  methods: {
    handleOper(row, status,str) {
      this.ruleForm.id = row.id
      this.ruleForm.status = status
      this.centerDialogVisible = true
      this.title = `${str}${row.device_name}${row.device_individual ? row.device_individual.serial_no : ''}的维护申请`
      // this.confirmBox('warning', `是否${str}${row.device_name}${row.device_individual?row.device_individual.serial_no:''}的维护申请`, { id:row.id, status }, this.setStatus);
    },
    async setStatus() {
      let res = await this.$api.instance.interfaceServer(`api/new_device/maintenance/review/${this.ruleForm.id}`, 'post', this.ruleForm);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '设置成功！',
        });
        this.centerDialogVisible = false
        this.getList();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/new_device/maintenance/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.beforeQueryByKey("structure_1", "structure_2")
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
